export default __webpack_public_path__ + "static/media/grafema_nutrana_02.eb13c8c0.mp4";